import { Head } from '@/components/head'
import { DrugPaymentSuccessPage } from '@/features/drug-payment/components/drug-payment-success-page'
import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

export const Route = createFileRoute('/drug-payment/success/$orderId')({
  component: RouteComponent,
  validateSearch: zodValidator(
    z.object({
      reference: z.string().optional(),
      referralId: z.string().optional(),
    }),
  ),
})

function RouteComponent() {
  const { orderId } = Route.useParams()
  const { reference, referralId } = Route.useSearch()

  return (
    <>
      <Head title="Payment Successful" />
      <DrugPaymentSuccessPage orderId={orderId} reference={reference} referralId={referralId} />
    </>
  )
}
